import { IParsedWhitelabelWithRelations } from '@/Interfaces/Whitelabels/Whitelabel.interface';
import { Autocomplete, TextField } from '@mui/material';
import { Control, Controller } from 'react-hook-form';

interface IProps {
  options: IParsedWhitelabelWithRelations[];
  shouldUnregister?: boolean;
  control: Control;
  name: string;
  id: string;
  placeholder: string;
  disabled?: boolean;
}

const OrganizationSelect = ({ control, shouldUnregister, options, name, id, placeholder, disabled }: IProps) => {
  return (
    <Controller
      name={name}
      rules={{
        required: {
          value: true,
          message: 'Please select an option.',
        },
      }}
      control={control}
      shouldUnregister={shouldUnregister}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          {...field}
          id={id}
          options={options}
          fullWidth
          disabled={disabled}
          onChange={(_, data) => field.onChange(data)}
          getOptionLabel={option => option?.name || ''}
          disableClearable
          isOptionEqualToValue={(option, selectValue) => selectValue && option.id === selectValue?.id}
          renderInput={params => (
            <TextField
              {...params}
              placeholder={placeholder}
              variant='outlined'
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      )}
    />
  );
};

export default OrganizationSelect;
